module.exports = __webpack_public_path__ + "static/media/writing.0d10dd5e.svg";